
import {
    Col,
    Input,
    Label,
} from "reactstrap";

const OtpEmailForm = ({ contactInfo, setContactInfo }) => {

    return (
        <>
            <div className="form-floating flex-grow-1">
                <Input
                    type="email"
                    placeholder="Enter your email address"
                    value={contactInfo}
                    onChange={(e) => setContactInfo(e.target.value)}
                    className="mb-2"
                    style={{
                        padding: "0.75rem 0.75rem 0.8rem 0.75rem",
                    }}
                />
                <Label for="mobile_number" className="form-label">
                    Enter your Email Address
                </Label>
            </div>
        </>
    );
};

export default OtpEmailForm;
